
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Collapse, Typography, Divider, message, } from "antd";
import AccountIntePage from './AccountIntePage'
import { setChatCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { fetchDomainAvaliability, extractDomain } from "../../../../Api/Services/CompanyApiService"
import Scoring from "../../TablesAndTimelines/ScoringGrapg"
import Meeting from "../../TablesAndTimelines/MeetingTable"
import { RelatedDocs } from '../GlobalComponents/RelatedDocUpload';
import { UserSideDiv } from '../GlobalComponents/UserCardCmnts'
import { ReportsIcon, ScoreIcon } from '../../../../components/Icons/Icons';
import { leadInsights } from '../../../../Api/Services/CommonApiService';

const { Panel } = Collapse;
const { Text } = Typography;

const NoteDetails = ({ displayData, profile, ViewDetailPage, UrlId, NacTrigger, setNaCTrigger, dataDisables, trigger }) => {
    const dispatch = useDispatch()
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const [userData, setUserData] = useState()
    const [report, setReport] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen4, setIsOpen4] = useState(false);
    const [isOpen2, setIsOpen2] = useState(true);
    const [isOpen3, setIsOpen3] = useState(true);
    const [openIntelligence, setOpenIntelligence] = useState(false);
    async function getUsersData(params) {
        try {
            const Response = await FetchUserDetails(params)
            setUserData(Response?.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getAccountReports(params) {
        try {
            const ValidDomain = await extractDomain(params)
            if (ValidDomain) {
                const Response = await fetchDomainAvaliability(ValidDomain)
                if (Response === "") {
                    setReport({ allow: false, data: null })
                }
                else {
                    setReport({ allow: true, data: Response })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    const handleExpand = (key) => {
        setIsOpen(key.length > 0);
    };
    const handleExpand4 = (key) => {
        setIsOpen4(key.length > 0);
    };
    const handleExpand2 = (key) => {
        setIsOpen2(key.length > 0);
    };
    const handleExpand3 = (key) => {
        setIsOpen3(key.length > 0);
    };
    useEffect(() => {
        if (isOpen4) {
            if (displayData?.lead_owner) {
                getUsersData(displayData?.lead_owner)
            } else {
                setUserData()
            }
        }
    }, [displayData?.lead_owner, isOpen4])
    useEffect(() => {
        if (isOpen2) {
            if (displayData?.website) {
                getAccountReports(displayData?.website)
            } else {
                setReport({ allow: false, data: null })
            }
        }
    }, [displayData?.website, isOpen2])
    const openTacking = () => {
        setOpenIntelligence(!openIntelligence)
    }
    const memoUrlId = useMemo(
        () => UrlId,
        [UrlId?.[0], UrlId?.[1]]
    );
    const openScoreGeniee = async () => {
        let hideMessage;
        try {
            hideMessage = message.loading("Gathering insights...", 0);
            const response = await leadInsights(companyProfile.companyCode, memoUrlId[1])
            if (response.status === 200 && response.statusText === "OK") {
                hideMessage();
                dispatch(setChatCall(true));
            }
        }
        catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    return (
        <>
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand3} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end">
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}> <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        minWidth: 0,
                    }}
                >
                    <Text
                        strong
                        style={{
                            fontSize: 14,
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                        }}
                    >
                        Candidate Score
                    </Text>
                    <div className='Hover-Refresh3 back-hover2 able-style'
                        role="button"
                        tabIndex={0} title='View Score Insights'
                        onClick={(e) => {
                            e.stopPropagation();   // ✅ IMPORTANT
                            openScoreGeniee();
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.stopPropagation();
                                openScoreGeniee()
                            }
                        }}
                        aria-label='insights'
                    ><ScoreIcon height={20} width={20} /></div>
                </div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen3 ? "Close" : "View"}</Text></div>} key="1">
                    <div className='RightSide-DataShadow' style={{ padding: "30px 10px" }}>
                        <Scoring UrlId={memoUrlId} NacTrigger={NacTrigger} trigger={trigger} />
                    </div>
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <Meeting UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} type="List" />
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" defaultActiveKey={["1"]} bordered={false} onChange={handleExpand2} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                minWidth: 0,
                            }}
                        >
                            <Text
                                strong
                                style={{
                                    fontSize: 14,
                                    whiteSpace: "nowrap",
                                    flexShrink: 0,
                                }}
                            >
                                Sponsor
                            </Text>
                            {isOpen2 ?
                                <div className={!report?.allow ? "disabled-style" : 'Hover-Refresh3 back-hover2 able-style'}
                                    role="button"
                                    tabIndex={0} title='View Account Intelligence Report'
                                    onClick={!report?.allow ? undefined : () => openTacking()}
                                    onKeyDown={(event) => {
                                        if (report?.allow && (event.key === 'Enter' || event.key === ' ')) {
                                            openTacking()
                                        }
                                    }}
                                    aria-label='report'
                                ><ReportsIcon height={20} width={20} /></div> : <></>}
                        </div>
                        <Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen2 ? "Close" : "View"}</Text></div>} key="1">
                    <div className='RightSide-DataShadow'>
                        <div className={`user-info_image ${dataDisables?.allow && "ListNavigate"}`} style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                            role="button" tabIndex={0}
                            onClick={dataDisables?.allow ? () => dataDisables?.id && ViewDetailPage(dataDisables?.id, "ACCOUNT") : undefined}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    ViewDetailPage(dataDisables?.id, "ACCOUNT")
                                }
                            }}>
                            {dataDisables?.profile !== null && dataDisables?.profile
                                !== undefined && dataDisables?.profile !== "" ?
                                <figure>
                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={dataDisables?.profile} alt="" />
                                </figure>
                                :
                                <span className='list_span_Tag AccountIcon' style={{ flexShrink: 0, }}>
                                    {displayData?.account_name?.slice(0, 1).toUpperCase()}
                                </span>}
                            <figcaption style={{
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden", // 👈 keeps ellipsis responsive
                            }}>
                                <div title={displayData?.account_name}
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }} >{displayData?.account_name}</div>
                                {/* <div style={{
                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }} title={displayData?.industry ? displayData.industryName : "Industry"}>{displayData?.industry ? displayData.industryName : "Industry"}</div> */}
                            </figcaption>
                        </div>
                        {(displayData?.nom_of_employees && displayData?.nom_of_employees !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Referral Source</Text>
                                <br />
                                <Text >{displayData?.nom_of_employees}</Text>
                            </div> : <></>}
                        {/* {(displayData?.annual_revenue && displayData?.annual_revenue !== "") ?
                            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                                <Text >{displayData?.annual_revenue}</Text>
                            </div> : <></>} */}
                        {(displayData?.rating && displayData?.rating !== "") ?
                            <div><Text type="secondary" className='RightSide-Lable'>Referrer Name & Role</Text> <br />
                                <Text >{displayData?.rating}</Text>
                            </div> : <></>}
                    </div>
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand4} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}><Text strong>Candidate Owner</Text><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen4 ? "Close" : "View"}</Text></div>} key="1">
                    <UserSideDiv userData={userData} />
                </Panel >
            </Collapse >
            <Divider style={{ margin: "10px 0" }} />
            <Collapse className="DetailsTabCollapse2" bordered={false} onChange={handleExpand} expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />} expandIconPosition="end"            >
                <Panel header={<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", }}><div style={{ fontWeight: 600 }}>Documents<span style={{ background: "#f0f0f0", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: 500, marginLeft: "10px", }}>{displayData?.lead_files?.length || 0}</span></div><Text type="secondary" style={{ marginRight: "12%", fontSize: 12 }}>{isOpen ? "Close" : "View"}</Text></div>} key="1">
                    {displayData?.lead_files?.map((file, index) => (
                        <RelatedDocs file={file} index={index} />
                    ))}
                </Panel>
            </Collapse>
            <Divider style={{ margin: "10px 0" }} />
            <AccountIntePage openIntelligence={openIntelligence} openTacking={openTacking} researchContent={report?.data} />
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    dataDisables: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    trigger: PropTypes.string.isRequired,
};
export default React.memo(NoteDetails)
